import { takeLatest, call, put, select } from 'redux-saga/effects';
import API_ENDPOINTS from '@services/apiConfig';
import axios from 'axios';
import AuthManager from '@services/AuthManager';


//  Action types
export const actionTypes = {
  fetchTokenInfo: 'tokenInfo/INITIATE',
  fetchTokenInfoSuccess: 'tokenInfo/SUCCESS',
};

const initialState = {
  processing: false,
  response: null
};

//  Reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchTokenInfo:
      return { processing: true, response: null };
    case actionTypes.fetchTokenInfoSuccess:
      return { processing: false, response: action.payload }
    default: {
      return state;
    }
  }
};

//  Selectors
export const selectors = {
  getPermissions: (state) => state.onboardingApp.acl.response,
};


//  Actions
export const actions = {
  fetchTokenInfo: () => ({ type: actionTypes.fetchTokenInfo }),
};

// Workers
function* fetchTokenInfoWorker() {
  const mid = AuthManager.getMID();
  try {
    const response = yield call(
      [axios, 'get'],
      API_ENDPOINTS.AUTH.TOKEN_INFO({ mid }),
    );
    yield put({ type: actionTypes.fetchTokenInfoSuccess, payload: response.data })
  } catch (err) {
    const errResponse = yield err.response;
  }
}


// Sagas
export function* saga() {
  yield takeLatest(actionTypes.fetchTokenInfo, fetchTokenInfoWorker);
}